<template>
    <div class="pages" :class="classObj">
        <div class="user_info">
            <div class="user_box" @click="toMyProfile">
                <img src="@/assets/person/avatar.png">
                <div>
                    <div class="phone">Hi,{{ userPhone }}</div>
                    <div @click.stop="copyText(userInfo.id)">
                        ID: {{ userInfo.id }}
                        <i class="iconfont icon-fuzhi"></i>
                    </div>
                </div>
                <div class="icon_logout" @click.stop="handleLogout">
                    <img src="@/assets/person/icon_logout.png" />
                </div>
            </div>
            <div class="vip_box" v-if="userInfo && vipList.length" @click="toVIP">
                <div class="next-vip">{{ $t("person.VIPNeed") }}{{ nextVipItem.memberLevelCode || 0 }}</div>
                <div class="vip_img">
                    <img :src="userInfo.levelDetailVo.memberLevelIcon" alt="">
                    <div class="vip_level">
                        VIP {{ userInfo.levelDetailVo.memberLevelCode || 0 }}
                    </div>
                </div>
                <div class="vip_info">
                    <div class="vip_progress">
                        <div class="rate">{{ $t('Vip.RechargeAmount') }}: <span>{{ formatAmount(userInfo.levelDetailVo.currentAmtRecharge ||
                            0) }}/{{ formatAmount(nextVipItem.amtRecharge || 0) }}</span></div>
                        <lineProgress :progress="userInfo.rechargeProgress" :height="0.18"></lineProgress>
                        <div class="rate">{{ $t('Vip.BetAmount') }}: <span>{{ formatAmount(userInfo.levelDetailVo.currentAmtOrder || 0
                        ) }}/{{ formatAmount(nextVipItem.amtOrder || 0) }}</span></div>
                        <lineProgress :progress="userInfo.betProgress" :height="0.18"></lineProgress>
                    </div>
                </div>
            </div>
            <div class="money_box">
                <div class="header">{{ $t("person.AccountTotal") }}</div>
                <div class="money_wrap">
                    <div>
                        <div class="money"> {{ formatAmount(allBalance, 2) }} </div>
                        <div> {{ $t('depositWithdraw.TotalBalance') }} </div>
                    </div>
                    <div>
                        <div class="money"> {{ formatAmount(useBalance, 2) }} </div>
                        <div> {{ $t('depositWithdraw.WithdrawableAmount') }} </div>
                    </div>
                </div>
                <div class="func_btns">
                    <div @click="toDeposit">
                        {{ $t("deposit.Deposit") }}
                    </div>
                    <div @click="toWithdraw">
                        {{ $t("Withdraw.Withdraw") }}
                    </div>
                </div>
            </div>
            <div class="contaItem" @click.stop="toShare">
                <div class="contaTitleLine">
                    {{ $t("share.PromotedAccount") }}
                </div>
                <div class="spreadLine">
                    <div class="spreadList">
                        <div v-if="invitationPageRewardState === 'enable'" class="spreadAmount">{{ formatCurrency(shareData.allGrandTotalDirectFirstAmt || 0) }}</div>
                        <div v-else>{{ CurrencyType }}0</div>
                        <div class="spreadName">{{ $t("share.TotalPrize") }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="spreadList">
                        <div v-if="invitationPageRewardState === 'enable'" class="spreadAmount">{{ formatCurrency(shareData.allUnDistributionFirstAmt || 0) }}</div>
                        <div v-else>{{ CurrencyType }}0</div>
                        <div class="spreadName">
                            {{ $t("share.BonusPendingSettlement") }}
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="spreadList">
                        <div v-if="invitationPageRewardState === 'enable'" class="spreadAmount">{{ formatCurrency(shareData.allDistributionFirstAmt || 0) }}</div>
                        <div v-else>{{ CurrencyType }}0</div>
                        <div class="spreadName">{{ $t("share.BonusesAlreadySettled") }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="menus">
            <div class="menus-item" @click.stop="$refs.RedemptionRecordPopup.open()">
                <span class="text">{{ $t("RedemptionCode.RedemptionRecord") }}</span>
            </div>
            <div v-if="invitationPageRewardState === 'enable'" class="menus-item" @click.stop="toTransaction">
                <span class="text">{{ $t("person.Transaction") }}</span>
            </div>
            <div class="menus-item" @click.stop="toBetHistory">
                <span class="text">{{ $t("person.History") }}</span>
            </div>
            <div class="menus-item" @click="toSetting">
                <span class="text">{{ $t("person.AccountSettings") }}</span>
            </div>
            <div class="menus-item" @click="$refs.lang.onShowLangPopup()">
                <span class="text"> {{ langType }}</span>
                <div class="language_box">
                    <language ref="lang" :show="true" :showIcon="false"></language>
                </div>
            </div>
            <div class="menus-item" @click="toNotification">
                <span class="text">{{ $t("person.LiveChat") }}</span>
            </div>
            <div class="menus-item" @click="onShowDownAppPopup">
                <span class="text">{{ $t("person.Install") }}</span>
            </div>
        </div>
        <div class="logout" @click="handleLogout">
            {{ $t("logout.SignOut") }}
        </div>
        <loginPopup @loginSucc="init"></loginPopup>
        <logoutPopup ref="logoutPopup" ></logoutPopup>
        <notification ref="notification"></notification>
        <!-- <BonusTransferPopup ref="BonusTransferPopup" @confirm="init"></BonusTransferPopup> -->
        <RedemptionRecordPopup ref="RedemptionRecordPopup"></RedemptionRecordPopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast } from 'vant'
import lineProgress from '@/components/lineProgress'
import handleCopy from '@/utils/copy.js'
import logoutPopup from '@/components/logoutPopup'
import notification from '@/components/notification'
import RedemptionRecordPopup from '@/components/RedemptionCodePopup/modules/RedemptionRecordPopup.vue'
// import BonusTransferPopup from '@/components/BonusTransferPopup'
import language from '@/components/language'
import {
    getListLevel,
    getUserInfo
} from '@/api/user'
import { getShareinfo } from '@/api/share'
import {
    domainName
} from '@/common/http/index.js'
export default {
    name: 'Person',
    components: { lineProgress, logoutPopup, notification, language, RedemptionRecordPopup },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        // userMoney() {
        //     // const userInfo = this.$store.getters.userInfo
        //     const info = {
        //         balanceAmtAccount: this.allBalance
        //         // bonusAmtAccount: userInfo.balanceAmtAccount ? userInfo.bonusAmtAccount.useBalance.toFixed(2) : '0.0'
        //     }
        //     return info
        // },
        useBalance() {
            const D = this.userInfo
            let balance = 0
            if (this.rate > 0 || (D && (!D.orderWater) && D.turnoverLimit)) {
                balance = 0
            } else if (D && D.memberDamaliangVoList && D.memberDamaliangVoList.length && D.memberDamaliangVoList.some(x => ((x.turnoverLimit || 0) - (x.orderWater || 0)) > 0)) {
                balance = 0
            } else {
                balance = this.userInfo.balanceAmtAccount ? this.userInfo.balanceAmtAccount.useBalance : 0
            }
            return balance
        },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        langType() {
            return this.langObj[this.$store.getters.language].name || 'English'
        },
        invitationPageRewardState() {
            return this.$store.getters.userInfo && this.$store.getters.userInfo.invitationPageRewardState
        }
    },
    data() {
        return {
            domainName: '',
            vipList: [],
            userInfo: {
                levelDetailVo: {
                    memberLevelIcon: '',
                    currentAmtRecharge: 0,
                    currentAmtOrder: 0,
                    memberLevelCode: 0
                }
            },
            rate: 0,
            orderWater: 0,
            nextVipItem: {},
            shareData: {}
        }
    },
    created() {
        this.domainName = domainName
    },
    activated() {
        const that = this
        if (!that.classObj.mobile) that.getShareInfo(true)
        that.getUserInfo().then(() => {
            that.getListLevel(true)
        })
    },
    methods: {
        init() {
            const that = this
            if (!that.classObj.mobile) that.getShareInfo(true)
            that.getUserInfo().then(() => {
                that.getListLevel(true)
            })
        },
        getUserInfo() {
            return new Promise((resolve, reject) => {
                getUserInfo().then((res) => {
                    const {
                        result,
                        code
                    } = res
                    if (code === 0) {
                        const D1 = result
                        this.userInfo = result
                        this.userInfo.levelDetailVo.currentAmtRecharge = result.levelDetailVo.currentAmtRecharge
                        this.userInfo.levelDetailVo.currentAmtOrder = result.levelDetailVo.currentAmtOrder
                        this.userInfo.levelDetailVo.memberLevelCode = result.levelDetailVo.memberLevelCode
                        const rate = ((D1.turnoverLimit || 0) - (D1.orderWater || 0)).toFixed(2)
                        this.rate = rate > 0 ? rate : 0
                        this.orderWater = D1.orderWater
                        resolve(result)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        getListLevel(isNoLoading) {
            const that = this
            getListLevel({}, isNoLoading).then((res) => {
                that.vipList = res.result
            }).then(() => {
                this.handleVipData()
            })
        },
        getShareInfo(isNoLoading) {
            getShareinfo({}, isNoLoading).then((res) => {
                if (res?.code) return
                const D = res?.result
                this.shareData = D
            })
        },
        handleVipData() {
            const that = this
            if (that.vipList.length && that.userInfo) {
                const nextLevel = that.userInfo.levelDetailVo.memberLevelCode + 1
                that.nextVipItem = that.vipList[nextLevel] || that.vipList[that.vipList.length - 1]
                that.userInfo.rechargeProgress = (that.userInfo.levelDetailVo.currentAmtRecharge / that.nextVipItem.amtRecharge) * 100
                that.userInfo.betProgress = (that.userInfo.levelDetailVo.currentAmtOrder / that.nextVipItem.amtOrder) * 100
                if (that.userInfo.rechargeProgress > 100) {
                    that.userInfo.rechargeProgress = 100
                }
                if (that.userInfo.betProgress > 100) {
                    that.userInfo.betProgress = 100
                }
                if (that.userInfo.levelDetailVo.currentAmtRecharge === 0) {
                    that.userInfo.rechargeProgress = 0
                }
                if (that.userInfo.levelDetailVo.currentAmtOrder === 0) {
                    that.userInfo.betProgress = 0
                }
                that.userInfo.rechargeDistance = that.nextVipItem.amtRecharge - that.userInfo.levelDetailVo.currentAmtRecharge
                that.userInfo.betDistance = that.nextVipItem.amtOrder - that.userInfo.levelDetailVo.currentAmtOrder
                // console.log(that.userInfo.levelDetailVo.currentAmtRecharge, that.userInfo.levelDetailVo.currentAmtOrder)
                // console.log(that.userInfo.rechargeProgress, that.userInfo.betProgress)
            }
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        toDeposit() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            if (this.$route.path.indexOf('/wallet?type=deposit') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toWithdraw() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            if (this.$route.path.indexOf('/wallet?type=Withdraw') !== -1) {
                return
            }
            const params = { type: 'Withdraw' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toMyProfile() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.$store.dispatch('user/setIsShowMyProfilePopup', true)
        },
        toBetHistory() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.$store.dispatch('user/setIsShowBetHistoryPopup', true)
        },
        toTransaction() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.$store.dispatch('user/setIsShowTransactionPopup', true)
        },
        toVIP() {
            if (this.$route.path.indexOf('/vip') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavToByIsLogin({ url: 'vip' })
        },
        toSetting() {
            if (this.$route.path.indexOf('/setting') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/setting' })
        },
        onShowDownAppPopup() {
            this.$store.dispatch('user/setIsShowDownAppPopup', true)
        },
        toShare() {
            if (this.$route.path.indexOf('/affiliate') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/affiliate' })
        },
        toNotification() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/notification' })
        }
    },
    watch: {
        classObj(newVal) {
            if (!newVal.mobile) {
                this.onPageRefresh()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.pages {
    width: 100%;
    height: 100%;
    background:
        radial-gradient(circle at top center, rgba($border-active-color, .22) 0%, rgba($border-active-color, 0) 42%),
        linear-gradient(180deg, rgba($bg-box-color, .96) 0%, rgba($bg-shell-color, 1) 100%);
    padding: .2rem .3rem .3rem;
    text-align: left;

    &.mobile{
        background:
            radial-gradient(circle at top center, rgba($border-active-color, .22) 0%, rgba($border-active-color, 0) 42%),
            linear-gradient(180deg, rgba($bg-box-color, .96) 0%, rgba($bg-shell-color, 1) 100%) !important;

        .contaItem{
            display: none;
        }

        .money_box{
            padding: 0 !important;
            background: transparent !important;
            border: 0 !important;
            box-shadow: none !important;
            .header{
                display: none !important;
            }
            .money_wrap{
                display: none;
            }

            .func_btns{
                margin: 0 !important;
                & > div{
                    border-radius: .15rem;
                    text-align: center;
                    border-color: $border-home-popup-color !important;
                    height: 1.2rem;
                    background-image: none !important;
                    box-shadow: $shadow-component-button-color !important;
                }
                & > div:first-child{
                    background:
                        radial-gradient(circle at 22% 0, rgba($border-active-color, .24) 0, rgba($border-active-color, 0) 38%),
                        linear-gradient(180deg, rgba($font-title-color, .22) 0%, rgba($font-title-color, .08) 24%, rgba($font-title-color, 0) 25%),
                        linear-gradient(90deg, rgba($border-active-color, 1) 0%, rgba($font-accent-color, .99) 42%, rgba($bg-popup-color, .96) 100%) !important;
                    color: $font-btn-color !important;
                }
                & > div:last-child{
                    background:
                        radial-gradient(circle at 18% 0, rgba($font-theme-color, .16) 0, rgba($font-theme-color, 0) 34%),
                        linear-gradient(180deg, rgba($font-title-color, .18) 0%, rgba($font-title-color, .06) 24%, rgba($font-title-color, 0) 25%),
                        linear-gradient(90deg, rgba($bg-popup-color, .92) 0%, rgba($bg-card-color, .94) 48%, rgba($bg-shell-color, .96) 100%) !important;
                    color: $font-home-primary-color !important;
                }
            }
        }
    }

    .user_info {
        position: relative;

        .user_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            margin-bottom: .2rem;
            padding: .16rem .22rem;
            border: 1px solid $border-home-popup-color !important;
            border-radius: .24rem;
            background:
                radial-gradient(circle at 18% 0, rgba($font-theme-color, .2) 0, rgba($font-theme-color, 0) 34%),
                linear-gradient(180deg, rgba($font-label-color, .08) 0%, rgba($font-label-color, 0) .18rem),
                linear-gradient(180deg, rgba($bg-card-color, .96) 0%, rgba($bg-box-color, .98) 56%, rgba($bg-shell-color, 1) 100%) !important;
            box-shadow: $shadow-affiliate-panel-color !important;

            .icon_logout {
                width: .98rem;
                height: .58rem;
                background: $bg-component-button-color;
                border: 1px solid $border-home-popup-color;
                box-shadow: $shadow-component-button-color;
                border-radius: .32rem;
                position: relative;
                right: auto;
                top: auto;
                transform: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                flex: none;

                &>img {
                    height: .34rem;
                    width: .34rem;
                    vertical-align: middle;
                    filter: brightness(1.2) sepia(.18);
                }
            }

            >img {
                width: 1.2rem;
                height: 1.2rem;
                border-radius: 50%;
                border: .04rem solid rgba($border-active-color, .34);
                box-shadow: 0 0 0 .02rem rgba($bg-shell-color, .22);
                margin-right: .2rem;
            }

            >div {
                flex: 1;
                min-width: 0;
                padding-right: .16rem;
                display: flex;
                flex-direction: column;
                justify-content: center;

                >div {
                    &:first-child {
                        height: .34rem;
                        line-height: .34rem;
                        color: $font-home-primary-color;
                        font-size: .32rem;
                        margin-bottom: .12rem;
                        font-weight: 700;
                        text-shadow: 0 1px 2px rgba($bg-shell-color, .24);
                    }

                    &:last-child {
                        height: .3rem;
                        line-height: .3rem;
                        color: $font-person-muted-color;
                        font-size: .24rem;
                        display: flex;
                        align-items: center;
                        gap: .06rem;

                        i {
                            cursor: pointer;
                            color: $font-person-accent-color;
                        }
                    }
                }
            }
        }

        .vip_box {
            display: flex;
            align-items: center;
            background: $bg-affiliate-panel-color;
            border: 1px solid $border-home-popup-color;
            border-radius: 10px;
            margin-bottom: 12px;
            cursor: pointer;
            overflow: hidden;
            position: relative;
            padding: 28px 20px 20px;
            column-gap: .18rem;

            .next-vip {
                position: absolute;
                top: 0;
                right: 0;
                background: $bg-person-tag-color;
                border-radius: 0 .16rem 0 0;
                font-size: .2rem;
                padding: .02rem .2rem .04rem .6rem;
                color: $font-title-color;
            }

            .vip_img {
                width: 1.46rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                flex: none;

                img {
                    width: 1.16rem;
                    height: .9rem;
                    vertical-align: middle;
                    object-fit: contain;
                    margin-bottom: .06rem;
                }

                .vip_level {
                    text-align: center;
                    font-size: .29rem;
                    font-weight: 800;
                    color: $font-person-accent-color;
                    font-style: italic;
                    line-height: 1;
                }
            }

            .vip_info {
                flex: 1;
                display: flex;
                align-items: flex-start;
                margin: 0;
                padding-top: .02rem;

                .vip_progress {
                    flex: 1;
                    padding-right: .04rem;

                    &:last-child {
                        color: $font-sub-color;
                        font-size: .2rem;

                        .rate {
                            font-size: .26rem;
                            color: $font-title-color;
                            margin: .02rem 0 .08rem;
                            line-height: 1.15;

                            &>span {
                                color: $font-person-accent-color;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }

        .func_btns {
            margin: .3rem .4rem .32rem;
            display: flex;
            justify-content: space-between;
            gap: .16rem;

            >div {
                height: .74rem;
                width: calc(50% - .08rem);
                display: flex;
                align-items: center;
                justify-content: center;
                color: $font-title-color;
                font-size: .28rem;
                border-radius: .18rem;
                font-weight: bold;
                cursor: pointer;
                background: linear-gradient(180deg, rgba($bg-box-color, .98) 0%, rgba($bg-shell-color, .98) 100%);
                border: 1px solid rgba($font-label-color, .18);
                box-shadow: inset 0 1px 0 rgba($font-title-color, .06);

                &:first-child {
                    background: $bg-home-popup-button-color;
                    color: $font-btn-color;
                    border-color: $border-home-popup-strong-color;
                    box-shadow: $shadow-component-button-color;
                }
            }
        }

        .money_box {
            width: 100%;
            background: $bg-affiliate-panel-color;
            border: 1px solid $border-home-popup-color;
            border-radius: .2rem;
            overflow: hidden;
            margin-bottom: .2rem;

            .header {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: .88rem;
                font-size: .25rem;
                color: $font-title-color;
                padding-left: .4rem;
            }

            .money_wrap {
                text-align: center;
                padding-top: .08rem;
                display: flex;
                align-items: center;
                justify-content: center;

                &>div{
                    width: 50%;
                }
                &>div>div:first-child {
                    color: $font-title-color;
                    font-size: .34rem;
                    line-height: 1.12;
                    font-weight: 700;
                    letter-spacing: .01rem;
                }

                &>div>div:last-child {
                    color: $font-person-muted-color;
                    font-size: .22rem;
                    margin-top: .07rem;
                }
            }
        }

        .contaItem {
            width: 100%;
            background: $bg-affiliate-panel-color;
            border: .01rem solid $border-home-popup-color;
            border-radius: .2rem;
            padding-bottom: .2rem;

            .contaTitleLine {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: .88rem;
                font-size: .25rem;
                color: $font-title-color;
                padding-left: .4rem;
                cursor: pointer;
                position: relative;

                &:after {
                    content: '';
                    width: .15rem;
                    height: .15rem;
                    border-top: .01rem solid $font-title-color;
                    border-right: .01rem solid $font-title-color;
                    position: absolute;
                    right: .4rem;
                    top: 50%;
                    transform: rotate(45deg) translateY(-50%);
                }
            }

            .spreadLine {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .spreadList {
                    text-align: center;
                    flex: 0 1 100%;
                    width: 33.3%;
                    color: $font-title-color;
                    font-size: .28rem;
                }

                .spreadName {
                    font-size: .24rem;
                    line-height: normal;
                    height: .5rem;
                    line-height: .25rem;
                    display: flex;
                    justify-content: center;
                    color: $font-person-muted-color;
                    white-space: pre-wrap;
                    text-align: center;
                }
            }

            .line {
                width: 1px;
                height: .7rem;
                background: rgba($font-title-color, .1);
            }
        }
    }

    .menus {
        width: 100%;
        margin: .2rem 0;
        padding: .2rem;
        border-radius: .2rem;
        color: $font-person-muted-color;
        font-size: .28rem;
        background: $bg-affiliate-panel-color;
        border: 1px solid $border-home-popup-color;

        .menus-item {
            // padding: 0 .42rem;
            height: .88rem;
            line-height: .88rem;
            text-align: left;
            color: $font-title-color;
            position: relative;
            border-bottom: 1px solid rgba($font-label-color, .12);
            cursor: pointer;

            &:last-child {
                border-bottom: 0;
            }

            &>i {
                font-size: .44rem;
                vertical-align: middle;
                margin-right: .2rem;
                color: $font-sub-color;
            }

            .language_box {
                position: absolute;
                top: -1rem;
                right: 0;
            }

            &:after {
                content: '';
                width: .17rem;
                height: .17rem;
                border-top: .02rem solid $font-title-color;
                border-right: .02rem solid $font-title-color;
                position: absolute;
                right: .4rem;
                top: 50%;
                transform: rotate(45deg) translateY(-50%);
            }
        }
    }

    .logout {
        color: $font-sub-color;
        margin: .3rem auto .6rem;
        font-size: .24rem;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
    }
    .vip_box,
    .money_box,
    .contaItem,
    .menus {
        background:
            radial-gradient(circle at 14% 0, rgba($font-theme-color, .18) 0, rgba($font-theme-color, 0) 34%),
            linear-gradient(180deg, rgba($font-label-color, .08) 0%, rgba($font-label-color, 0) .18rem),
            linear-gradient(180deg, rgba($bg-card-color, .98) 0%, rgba($bg-box-color, .99) 56%, rgba($bg-shell-color, 1) 100%);
        border-color: $border-home-popup-color;
        box-shadow: $shadow-affiliate-panel-color;
    }

    .vip_box .next-vip {
        background: $bg-person-tag-color;
    }

    .vip_box .vip_img .vip_level,
    .vip_box .vip_info .vip_progress:last-child .rate > span {
        color: $font-person-accent-color;
    }

    .money_box .money_wrap > div:last-child,
    .contaItem .spreadLine .spreadName {
        color: $font-person-muted-color;
    }

    .func_btns > div {
        background:
            linear-gradient(180deg, rgba($font-title-color, .18) 0%, rgba($font-title-color, .06) 24%, rgba($font-title-color, 0) 25%),
            linear-gradient(90deg, rgba($bg-popup-color, .92) 0%, rgba($bg-card-color, .94) 48%, rgba($bg-shell-color, .96) 100%);
        color: $font-home-primary-color;
        box-shadow: $shadow-component-button-color;
    }

    .func_btns > div:first-child {
        background:
            linear-gradient(180deg, rgba($font-title-color, .24) 0%, rgba($font-title-color, .08) 26%, rgba($font-title-color, 0) 27%),
            linear-gradient(90deg, rgba($border-active-color, 1) 0%, rgba($font-accent-color, .99) 42%, rgba($bg-popup-color, .96) 100%);
        color: $font-btn-color;
        box-shadow: $shadow-component-button-color;
    }

    .func_btns > div:last-child {
        border: 1px solid $border-home-popup-color;
    }

    .menus {
        color: $font-person-muted-color;
    }

    .menus .menus-item {
        border-bottom-color: rgba($font-label-color, .12);
    }

    .user_info {
        background: $bg-person-user-info-color !important;
        box-shadow: inset 0 1px 0 rgba($font-label-color, .08) !important;

        .icon_logout {
            background:
                linear-gradient(180deg, rgba($font-title-color, .18) 0%, rgba($font-title-color, .06) 24%, rgba($font-title-color, 0) 25%),
                linear-gradient(90deg, rgba($bg-popup-color, .92) 0%, rgba($bg-card-color, .94) 48%, rgba($bg-shell-color, .96) 100%) !important;
            border: 1px solid $border-home-popup-color !important;
            box-shadow: $shadow-component-button-color !important;
        }
    }

    .vip_box,
    .money_box,
    .contaItem,
    .menus,
    .pages .vip_box,
    .pages .money_box,
    .pages .contaItem,
    .pages .menus {
        background:
            radial-gradient(circle at 14% 0, rgba($font-theme-color, .18) 0, rgba($font-theme-color, 0) 34%),
            linear-gradient(180deg, rgba($font-label-color, .08) 0%, rgba($font-label-color, 0) .18rem),
            linear-gradient(180deg, rgba($bg-card-color, .98) 0%, rgba($bg-box-color, .99) 56%, rgba($bg-shell-color, 1) 100%) !important;
        border-color: $border-home-popup-color !important;
        box-shadow: $shadow-affiliate-panel-color !important;
    }

    .pages .money_box .header,
    .pages .contaItem .contaTitleLine,
    .pages .menus .menus-item,
    .pages .money_box .money_wrap > div:first-child,
    .pages .vip_box .vip_info .vip_progress:last-child .rate {
        color: $font-home-primary-color !important;
    }

    .pages .money_box .money_wrap > div:last-child,
    .pages .contaItem .spreadLine .spreadName,
    .pages .menus {
        color: $font-person-muted-color !important;
    }

    .pages .contaItem .line,
    .pages .menus .menus-item {
        border-bottom-color: rgba($font-label-color, .12) !important;
    }

    .pages .func_btns > div {
        background:
            linear-gradient(180deg, rgba($font-title-color, .18) 0%, rgba($font-title-color, .06) 24%, rgba($font-title-color, 0) 25%),
            linear-gradient(90deg, rgba($bg-popup-color, .92) 0%, rgba($bg-card-color, .94) 48%, rgba($bg-shell-color, .96) 100%) !important;
        color: $font-home-primary-color !important;
        border-color: $border-home-popup-color !important;
        box-shadow: $shadow-component-button-color !important;
    }

    .pages .func_btns > div:first-child {
        background:
            linear-gradient(180deg, rgba($font-title-color, .24) 0%, rgba($font-title-color, .08) 26%, rgba($font-title-color, 0) 27%),
            linear-gradient(90deg, rgba($border-active-color, 1) 0%, rgba($font-accent-color, .99) 42%, rgba($bg-popup-color, .96) 100%) !important;
        color: $font-btn-color !important;
        box-shadow: $shadow-component-button-color !important;
    }

    .content .pages .func_btns > div,
    .popup .pages .func_btns > div {
        background:
            linear-gradient(180deg, rgba($font-title-color, .18) 0%, rgba($font-title-color, .06) 24%, rgba($font-title-color, 0) 25%),
            linear-gradient(90deg, rgba($bg-popup-color, .92) 0%, rgba($bg-card-color, .94) 48%, rgba($bg-shell-color, .96) 100%) !important;
        color: $font-home-primary-color !important;
        border: 1px solid $border-home-popup-color !important;
    }

    .content .pages .func_btns > div:first-child,
    .popup .pages .func_btns > div:first-child {
        background:
            linear-gradient(180deg, rgba($font-title-color, .24) 0%, rgba($font-title-color, .08) 26%, rgba($font-title-color, 0) 27%),
            linear-gradient(90deg, rgba($border-active-color, 1) 0%, rgba($font-accent-color, .99) 42%, rgba($bg-popup-color, .96) 100%) !important;
        color: $font-btn-color !important;
    }

    &.mobile {
        .user_info .user_box {
            background:
                radial-gradient(circle at 18% 0, rgba($font-theme-color, .2) 0, rgba($font-theme-color, 0) 34%),
                linear-gradient(180deg, rgba($font-label-color, .08) 0%, rgba($font-label-color, 0) .18rem),
                linear-gradient(180deg, rgba($bg-card-color, .96) 0%, rgba($bg-box-color, .98) 56%, rgba($bg-shell-color, 1) 100%) !important;
            border-color: $border-home-popup-color !important;
            box-shadow: $shadow-affiliate-panel-color !important;
        }

        .user_info .user_box .icon_logout {
            background:
                linear-gradient(180deg, rgba($font-title-color, .18) 0%, rgba($font-title-color, .06) 24%, rgba($font-title-color, 0) 25%),
                linear-gradient(90deg, rgba($bg-popup-color, .92) 0%, rgba($bg-card-color, .94) 48%, rgba($bg-shell-color, .96) 100%) !important;
            border-color: $border-home-popup-color !important;
            box-shadow: $shadow-component-button-color !important;
        }

        .user_info .user_box > div .phone,
        .user_info .user_box > div > div,
        .money_box .header,
        .money_box .money_wrap > div:first-child,
        .contaItem .contaTitleLine,
        .menus .menus-item {
            color: $font-home-primary-color !important;
        }

        .vip_box,
        .money_box,
        .contaItem,
        .menus {
            background:
                radial-gradient(circle at 18% 0, rgba($font-theme-color, .2) 0, rgba($font-theme-color, 0) 34%),
                linear-gradient(180deg, rgba($font-label-color, .08) 0%, rgba($font-label-color, 0) .18rem),
                linear-gradient(180deg, rgba($bg-card-color, .96) 0%, rgba($bg-box-color, .98) 56%, rgba($bg-shell-color, 1) 100%) !important;
            border-color: $border-home-popup-color !important;
            box-shadow: $shadow-affiliate-panel-color !important;
        }

        .vip_box .next-vip {
            background: $bg-person-tag-color !important;
        }

        .vip_box .vip_img .vip_level,
        .vip_box .vip_info .vip_progress .rate span,
        .contaItem .spreadLine .spreadAmount {
            color: $font-person-accent-color !important;
        }

        .money_box .money_wrap > div:last-child,
        .contaItem .spreadLine .spreadName,
        .menus {
            color: $font-person-muted-color !important;
        }

        .menus .menus-item,
        .contaItem .line {
            border-bottom-color: rgba($font-label-color, .12) !important;
        }
    }

    .content .pages .user_info .user_box .icon_logout,
    .popup .pages .user_info .user_box .icon_logout,
    .content .pages .func_btns > div,
    .popup .pages .func_btns > div {
        background:
            linear-gradient(180deg, rgba($font-title-color, .18) 0%, rgba($font-title-color, .06) 24%, rgba($font-title-color, 0) 25%),
            linear-gradient(90deg, rgba($bg-popup-color, .92) 0%, rgba($bg-card-color, .94) 48%, rgba($bg-shell-color, .96) 100%) !important;
        color: $font-home-primary-color !important;
        border: 1px solid $border-home-popup-color !important;
        box-shadow: $shadow-component-button-color !important;
    }

    .content .pages .func_btns > div:first-child,
    .popup .pages .func_btns > div:first-child {
        background:
            linear-gradient(180deg, rgba($font-title-color, .24) 0%, rgba($font-title-color, .08) 26%, rgba($font-title-color, 0) 27%),
            linear-gradient(90deg, rgba($border-active-color, 1) 0%, rgba($font-accent-color, .99) 42%, rgba($bg-popup-color, .96) 100%) !important;
        color: $font-btn-color !important;
        border-color: rgba($border-active-color, .42) !important;
    }

    .content .pages .func_btns > div:last-child,
    .popup .pages .func_btns > div:last-child {
        background:
            linear-gradient(180deg, rgba($font-title-color, .12) 0%, rgba($font-title-color, .04) 24%, rgba($font-title-color, 0) 25%),
            linear-gradient(90deg, rgba($bg-popup-color, .94) 0%, rgba($bg-card-color, .96) 48%, rgba($bg-shell-color, .98) 100%) !important;
        color: $font-home-primary-color !important;
        border: 1px solid $border-home-popup-color !important;
        box-shadow: $shadow-component-button-color !important;
    }

    .content .pages .money_box,
    .content .pages .contaItem,
    .content .pages .menus,
    .popup .pages .money_box,
    .popup .pages .contaItem,
    .popup .pages .menus {
        background:
            radial-gradient(circle at 14% 0, rgba($font-theme-color, .18) 0, rgba($font-theme-color, 0) 34%),
            linear-gradient(180deg, rgba($font-label-color, .08) 0%, rgba($font-label-color, 0) .18rem),
            linear-gradient(180deg, rgba($bg-card-color, .98) 0%, rgba($bg-box-color, .99) 56%, rgba($bg-shell-color, 1) 100%) !important;
        border-color: $border-home-popup-color !important;
        box-shadow: $shadow-affiliate-panel-color !important;
    }
}</style>
